import { createContext } from 'react';
import { ThemeType } from '@/utils/theme';

export interface ThemeContextType {
  theme: ThemeType;
}

export const defaultTheme: ThemeContextType = {
  theme: ThemeType.Light,
};

export const ThemeContext = createContext<ThemeContextType>(defaultTheme);
ThemeContext.displayName = 'ThemeContext';
